export enum DesignType {
    BrandDesign = 'Design::BrandDesign',
    EmailDesign = 'Design::EmailDesign',
    ExportDesign = 'Design::ExportDesign',
    SubmissionDesign = 'Design::SubmissionDesign'
}
